import React, { useEffect, useState } from 'react';

import { Button, Paper } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';

import { getAppUser } from '../../../../services/user.service';

import { AuthProfile } from '../../../../types/AuthProfile';
import { AppUser } from '../../../../types/AppUser';

import AppUserForm from '../../account/appUserForm';
import AppUserDetail from '../../account/appUserDetail';

import UserPermissions from '../../authorization/appuser/userPermissions';
import UserScopeView from '../../authorization/appuser/userScopeView';
import AppUserRoleWarnings from '../../authorization/appuser/appUserRoleWarnings';
import UserRoles from '../../authorization/appuser/UserRoles';

// Styles
import '../../../../styles/muiTabs.scss';
interface AppUserConfigProps {
  id: string;
  handleUserConfiguration: (id: string) => void;
}

export default function AppUserConfig({ id, handleUserConfiguration }: AppUserConfigProps) {
  const [activeTab, setActiveTab] = useState<string>('general');
  const [authProfile, setAuthProfile] = useState<AuthProfile>();
  const [appUser, setAppUser] = useState<AppUser>();

  useEffect(() => {
    getAppUser(id)
      .then((response) => setAppUser(response))
      .catch((err) => console.error('Unable to fetch user', err));
  }, [id]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => setActiveTab(newValue);

  return (
    <>
      {appUser && <AppUserDetail showBackButton={false} appUser={appUser} />}
      <TabContext value={activeTab}>
        <div className='app-tabs'>
          <TabList onChange={handleTabChange}>
            <Tab label='Details' value='general' sx={{ textTransform: 'none' }} />
            <Tab label='Roles' value='roles' sx={{ textTransform: 'none' }} />
            <Tab label='Permissions' value='permissions' sx={{ textTransform: 'none' }} />
            <Tab label='Scopes' value='scopes' sx={{ textTransform: 'none' }} />
          </TabList>
        </div>
        <TabPanel value='general'>
          <AppUserForm appUser={appUser} setAppUser={setAppUser} />
        </TabPanel>
        <TabPanel value='roles'>
          <AppUserRoleWarnings user={appUser} />
          <UserRoles appUserId={appUser?.id ?? id} authProfile={authProfile} setAuthProfile={setAuthProfile} />
        </TabPanel>
        <TabPanel value='permissions'>
          <UserPermissions userId={appUser?.id ?? id} isFromAppUserConfig={true} />
        </TabPanel>
        <TabPanel value='scopes'>
          <Paper>
            <UserScopeView userId={appUser?.id ?? id} />
          </Paper>
        </TabPanel>
      </TabContext>
      <Button
        variant='contained'
        size='small'
        style={{ position: 'absolute', bottom: 8, right: 90 }}
        onClick={() => handleUserConfiguration(appUser?.id ?? id)}
      >
        Complete Configuration
      </Button>
    </>
  );
}
